<template>
  <div id="app" class="components-page d-flex flex-column align-items-center">
    <div v-if="!showingComponents" class="content-container d-flex flex-column align-items-center justify-content-center align-items-center">
      <img src="../src/assets/intro/logociclo2.png" alt="Imagen" class="content-image">
      <div class="buttons-container">
        <button @click="navigateTo('perio/cirugia/implantes/prosto', [1, 2, 3, 4, 5, 6, 7, 8, 9, 11, 12])" class="button-perio">PERIO CIRUGÍA IMPLANTES PROSTO</button>
        <button @click="navigateTo('ortho/odontoped', [1, 10, 3, 4, 2, 13, 7, 8, 11, 12])" class="button-ortho">ORTHO ODONTOPED</button>
        <button @click="navigateTo('general/endodoncia/estetica', [1, 5, 6, 3, 4, 2, 13, 7, 8, 9, 11, 12])" class="button-general">GENERAL ENDODONCIA ESTÉTICA</button>
      </div>
    </div>
    <div v-else class="components-container d-flex flex-column align-items-stretch">
      <div v-for="section in visibleComponents" :key="section" class="full-width">
        <component :is="getComponent(section)" />
      </div>
      <button @click="goBack" class="back-button"></button>
    </div>
  </div>
</template>

<script>
import Intro from './components/Intro.vue';
import PerioGardRegimen from './components/PerioGardRegimen.vue';
import PerioGardOne from './components/PerioGardOne.vue';
import PerioGardTwo from './components/PerioGardTwo.vue';
import SensitiveOne from './components/SensitiveOne.vue';
import SensitiveTwo from './components/SensitiveTwo.vue';
import PerioGardThree from './components/PerioGardThree.vue';
import TotalOne from './components/TotalOne.vue';
import TotalOnev2 from './components/TotalOnev2.vue';
import TotalOnev3 from './components/TotalOnev3.vue';
import TotalTwo from './components/TotalTwo.vue';
import SlimSoft from './components/SlimSoft.vue';
import OrthoGard from './components/OrthoGard.vue';
import Duraphat from './components/Duraphat.vue';
import Pass from './components/Pass.vue';

export default {
  components: {
    Intro,
    PerioGardRegimen,
    PerioGardOne,
    PerioGardTwo,
    PerioGardThree,
    SensitiveOne,
    SensitiveTwo,
    TotalOne,
    TotalOnev2,
    TotalOnev3,
    TotalTwo,
    SlimSoft,
    OrthoGard,
    Duraphat,
    Pass
  },
  data() {
    return {
      visibleComponents: [],
      showingComponents: false
    };
  },
  methods: {
    navigateTo(slug, components) {
      this.visibleComponents = components;
      this.showingComponents = true;
      window.history.pushState({}, '', `#${slug}`);
    },
    goBack() {
      this.showingComponents = false;
      this.visibleComponents = [];
      window.history.pushState({}, '', '#');
    },
    getComponent(index) {
      const componentMap = {
        1: 'Intro',
        2: 'PerioGardRegimen',
        3: 'PerioGardOne',
        4: 'PerioGardTwo',
        5: 'SensitiveOne',
        6: 'SensitiveTwo',
        7: 'TotalOne',
        8: 'TotalTwo',
        9: 'SlimSoft',
        10: 'OrthoGard',
        11: 'Duraphat',
        12: 'Pass',
        13: 'PerioGardThree',
        14: 'TotalOnev2',
        15: 'TotalOnev3'
      };
      return componentMap[index];
    }
  }
};
</script>

<style>
html, body {
  overflow-x: hidden;
  background-color: #EEF2F5;
}

@import 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css';

.content-container {
  width: 70%;
  position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.components-page {
  text-align: center;
}

.components-container {
  width: 100%;
}

.back-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 50px;
  height: 50px;
  background: url('../src/assets/home_ciclo6.svg') no-repeat center center;
  background-size: contain;
  border: none;
  cursor: pointer;
}

.buttons-container {
  display: flex;
  gap: 15px;
  border: none;
}

.button-perio {
  background: #287db2;
  border: none;
  padding: 10px;
  border-radius: 15px;
  color: #fff;
}

.button-ortho {
  background: #56ad96;
  border: none;
  padding: 10px;
  border-radius: 15px;
  color: #fff;
}

.button-general {
  background: #bea43f;
  border: none;
  padding: 10px;
  border-radius: 15px;
  color: #fff;
}
  
.content-image {
  width: 33%;
  padding-bottom: 30px;
}
</style>
